import React, { Component } from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros'
import {
    descargarObleaVentaVerdeApi,
    fetchComprobanteVentaVerdeApi,
    guardarDescargaObleaVentaVerdeApi
} from '../../../api/axios'
import { base64ToArrayBuffer, saveByteArray, saveByteArrayJpg } from "../../../utilities/formatFile";
import { toast } from 'react-toastify';
import { filtroHoy } from "../../../utilities/fechasFiltro";
import MiniSpinner from "../../General/MiniSpinner";

export default class OrdenProvListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            obleaDescargada: this.props.obleaDescargada,
            showSpinner: false
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.obleaDescargada !== this.props.obleaDescargada) {
            this.setState({ obleaDescargada: this.props.obleaDescargada });
        }
    }

    descargarOblea = (e) => {
        e.preventDefault();

        this.setState({ showSpinner: true });
        let factura = descargarObleaVentaVerdeApi({ IdVenta: parseInt(e.target.id) });

        factura.then(res => {
            let pdfData = base64ToArrayBuffer(res.oblea);
            saveByteArrayJpg("Oblea.pdf", pdfData);
            toast.success("Descarga realizada");

            const { idOrden, userId } = this.props;

            let guardar = guardarDescargaObleaVentaVerdeApi({
                idUsuario: userId,
                IdOrden: idOrden,
                FechaDescarga: filtroHoy(),
                Borrado: true,
                FechaActualizacion: filtroHoy()
            });

            guardar.then(res => {
                toast.success("Estado actualizado");
                this.setState({ obleaDescargada: true });
            }).catch(() => {
                toast.error("El estado de la oblea no pudo ser actualizado");
            });
        }).catch(() => {
            toast.error("Descarga fallida");
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    }

    descargarComprobante = (e) => {
        e.preventDefault();
        let factura = fetchComprobanteVentaVerdeApi({ comprobante: e.target.id });
        factura.then(res => {
            let pdfData = base64ToArrayBuffer(res.factura);
            saveByteArray("Factura", pdfData);
            toast.success("Descarga realizada");
        }).catch(err => {
            toast.error("Descarga fallida");
        });
    }

    render = () => {
        const {
            idOrden,
            fecha,
            cliente,
            montoVenta,
            productos,
            mailCliente,
            dniIdBocaSeller,
            plataformaCodigo,
            comprobante
        } = this.props;

        const switchLogo = (plataformaCodigo) => {
            switch (plataformaCodigo) {
                case 0:
                    return '/img/icono-megatone.png'
                case 1:
                    return '/img/icono-mega-Market.png'
                case 2:
                    return '/img/icono-megatone-express.png'
                default:
                    return ""
            }
        }

        return (
            <div className="container list-group-item hover-background-color">
                <div className="row align-items-center">

                    <div className="col-2 col-lg-1 text-center text-break">
                        <span className="d-block font-size-072rem">{fecha.slice(0, 10)}</span>
                        <span className="d-block font-size-072rem">{idOrden}</span>
                    </div>

                    <div className="col-2 col-md-2 text-center">

                        <small className="font-14 font-weight-bold applyFont text-break d-block my-1">
                            {cliente}
                        </small>

                        <small
                            hidden={mailCliente.length < 1}
                            className="applyFont text-break d-block my-1"
                        >
                            {mailCliente}
                        </small>

                        <img
                            src={process.env.PUBLIC_URL + switchLogo(plataformaCodigo)}
                            alt=""
                            style={{ width: "50px" }}
                            className="my-1"
                        />

                        <small className="d-block fw-bold mt-1">
                            {dniIdBocaSeller != 0 ? dniIdBocaSeller : ""}
                        </small>
                    </div>

                    <div className="col-md-5 col-lg-5 col-5 align-self-center">
                        {
                            productos.map((producto, index, { length }) => {
                                return (
                                    <div className="row" key={index}>
                                        <div className="col-md-3 col-lg-3 col-sm-3 text-center">
                                            <img
                                                alt={producto?.titulo}
                                                className="mw-60px img-responsive"
                                                src={producto.imagenPrincipal != ""
                                                    ? producto.imagenPrincipal
                                                    : "https://www.megatone.net/Images/Marketplaces/EnProceso_zoom2x.png"
                                                }
                                            />
                                        </div>
                                        <div className="col-md-9">
                                            <h6 className="box-title m-b-5 font-weight-bold">
                                                <small className="applyFont">
                                                    {producto.cantidad} x
                                                </small>
                                                {producto.titulo}
                                            </h6>
                                            <small className="applyFont d-block">
                                                Precio unitario: ${formatoDecimal(producto.precioUnitario)}
                                            </small>
                                            <small className="applyFont d-block">
                                                SKU Market: {producto.skuMarket}
                                            </small>
                                        </div>
                                        <div className="col-9 col-md-10 border-bottom" hidden={index + 1 === length} />
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className="col-2 col-md-2 div-center text-break">
                        <h5 className="font-weight-bold box-title d-block">${formatoDecimal(montoVenta)}</h5>
                    </div>

                    <div className="col-2 col-md-2 div-center text-break">
                        <div className="custom-control form-switch">

                            {this.state.showSpinner ? <MiniSpinner /> :
                                <button
                                    type="button"
                                    onClick={this.descargarOblea}
                                    id={idOrden}
                                    className="btn btn-sm btn-green"
                                >
                                    {this.state.obleaDescargada ? "Volver a Descargar Oblea" : "Descargar Oblea"}
                                </button>
                            }

                            <button
                                type="button"
                                onClick={this.descargarComprobante}
                                id={comprobante}
                                className="btn btn-sm btn-green my-2"
                            >
                                Descargar Comprobante
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}